import { pdkAxios } from '@/lib/pdk-axios';
import type { Deal } from '@/models/registry';
import { dealStore } from '@/models/stores/deals';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Pencil } from 'lucide-react';

export const useDeletePaymentMutation = ({
  dealId,
  paymentId,
}: {
  dealId: Deal['id'];
  paymentId: Deal['payments'][0]['id'] | null;
}) => {
  const queryClient = useQueryClient();
  const deletePaymentMutation = useMutation({
    onMutate: async () => {
      if (!paymentId) {
        console.error('No payment id provided');
        return;
      }

      dealStore.removePayment(paymentId, dealId);
    },
    mutationFn: async ({
      paymentId,
    }: {
      paymentId: Deal['payments'][0]['id'];
    }): Promise<Deal['payments']> => {
      const route = `deals/${dealId}/payments/${paymentId}/delete`;
      // /deals/:id/payments/:payment_id/delete

      const response = await pdkAxios
        .post(`/${route}`, {
          // sales_reps: salesRepsIds,
        })
        .catch((e) => {
          console.error('Error deleting payment', e);
          throw e;
        });

      return response.data;
    },
    onSuccess: () => {},
    onError: (error, variables) => {
      console.error('Error deleting payment', error, variables);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['deal', dealId] });
    },
  });

  return { deletePaymentMutation };
};

const PaymentEditMenuItem = ({
  // dealId,
  payment,
  onSelect,
}: {
  // dealId: Deal["id"];
  payment: Deal['payments'][0];
  onSelect: (paymentId: Deal['payments'][0]['id']) => void;
}) => {
  return (
    <div
      className="flex flex-row gap-2 w-full items-center"
      onClick={() => {
        onSelect(payment.id);
      }}
    >
      <Pencil className="size-3.5" />
      <div className="flex flex-col text-nowrap truncate">
        <p className="text-xs">Update payment</p>
        {/* <p className="text-xs text-muted-foreground">{tradeIn.vin}</p> */}
      </div>
    </div>
  );
};

export default PaymentEditMenuItem;
